var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{class:{ playing: _vm.isAudioPlaying, paused: !_vm.isAudioPlaying },on:{"click":_vm.toggle}},[_c('BaseSpriteIcon',{attrs:{"icon-name":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }